// const BASE_URL = 'https://arkiart-backend-sgcqkoiltq-no.a.run.app'
const BASE_URL = 'https://arkiart-auth.onrender.com'

export const API_URL = (slug) => `${BASE_URL}/${slug}`